import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ConnectionAckServerMessageClass;
function ConnectionAckServerMessage() {
  if (ConnectionAckServerMessageClass === VOID) {
    class $ {}
    initMetadataForObject($, 'ConnectionAckServerMessage');
    ConnectionAckServerMessageClass = $;
  }
  return ConnectionAckServerMessageClass;
}
var ConnectionAckServerMessage_instance;
function ConnectionAckServerMessage_getInstance() {
  return ConnectionAckServerMessage_instance;
}
var ConnectionErrorServerMessageClass;
function ConnectionErrorServerMessage() {
  if (ConnectionErrorServerMessageClass === VOID) {
    class $ {}
    initMetadataForClass($, 'ConnectionErrorServerMessage');
    ConnectionErrorServerMessageClass = $;
  }
  return ConnectionErrorServerMessageClass;
}
var ResponseServerMessageClass;
function ResponseServerMessage() {
  if (ResponseServerMessageClass === VOID) {
    class $ {
      constructor(id, response) {
        this.p66_1 = id;
        this.q66_1 = response;
      }
    }
    initMetadataForClass($, 'ResponseServerMessage');
    ResponseServerMessageClass = $;
  }
  return ResponseServerMessageClass;
}
var CompleteServerMessageClass;
function CompleteServerMessage() {
  if (CompleteServerMessageClass === VOID) {
    class $ {
      constructor(id) {
        this.r66_1 = id;
      }
    }
    initMetadataForClass($, 'CompleteServerMessage');
    CompleteServerMessageClass = $;
  }
  return CompleteServerMessageClass;
}
var OperationErrorServerMessageClass;
function OperationErrorServerMessage() {
  if (OperationErrorServerMessageClass === VOID) {
    class $ {
      constructor(id, payload) {
        this.s66_1 = id;
        this.t66_1 = payload;
      }
    }
    initMetadataForClass($, 'OperationErrorServerMessage');
    OperationErrorServerMessageClass = $;
  }
  return OperationErrorServerMessageClass;
}
var ParseErrorServerMessageClass;
function ParseErrorServerMessage() {
  if (ParseErrorServerMessageClass === VOID) {
    class $ {
      constructor(errorMessage) {
        this.u66_1 = errorMessage;
      }
    }
    initMetadataForClass($, 'ParseErrorServerMessage');
    ParseErrorServerMessageClass = $;
  }
  return ParseErrorServerMessageClass;
}
var PingServerMessageClass;
function PingServerMessage() {
  if (PingServerMessageClass === VOID) {
    class $ {}
    initMetadataForObject($, 'PingServerMessage');
    PingServerMessageClass = $;
  }
  return PingServerMessageClass;
}
var PingServerMessage_instance;
function PingServerMessage_getInstance() {
  return PingServerMessage_instance;
}
var PongServerMessageClass;
function PongServerMessage() {
  if (PongServerMessageClass === VOID) {
    class $ {}
    initMetadataForObject($, 'PongServerMessage');
    PongServerMessageClass = $;
  }
  return PongServerMessageClass;
}
var PongServerMessage_instance;
function PongServerMessage_getInstance() {
  return PongServerMessage_instance;
}
var ConnectionKeepAliveServerMessageClass;
function ConnectionKeepAliveServerMessage() {
  if (ConnectionKeepAliveServerMessageClass === VOID) {
    class $ {}
    initMetadataForObject($, 'ConnectionKeepAliveServerMessage');
    ConnectionKeepAliveServerMessageClass = $;
  }
  return ConnectionKeepAliveServerMessageClass;
}
var ConnectionKeepAliveServerMessage_instance;
function ConnectionKeepAliveServerMessage_getInstance() {
  return ConnectionKeepAliveServerMessage_instance;
}
//region block: init
ConnectionAckServerMessage_instance = new (ConnectionAckServerMessage())();
PingServerMessage_instance = new (PingServerMessage())();
PongServerMessage_instance = new (PongServerMessage())();
ConnectionKeepAliveServerMessage_instance = new (ConnectionKeepAliveServerMessage())();
//endregion
//region block: exports
export {
  CompleteServerMessage as CompleteServerMessage1c62v9ocjho2f,
  ConnectionErrorServerMessage as ConnectionErrorServerMessage21355wd69v8tf,
  OperationErrorServerMessage as OperationErrorServerMessage3f3enfqsilvrv,
  ParseErrorServerMessage as ParseErrorServerMessage28gxznaow3b26,
  ResponseServerMessage as ResponseServerMessage1aifb0dqdz3sq,
  ConnectionAckServerMessage_instance as ConnectionAckServerMessage_instance2uyrftb08sig4,
  ConnectionKeepAliveServerMessage_instance as ConnectionKeepAliveServerMessage_instance2ucdc3b7nis36,
  PingServerMessage_instance as PingServerMessage_instance2x2b9b7bh91v2,
  PongServerMessage_instance as PongServerMessage_instancegdhl9dh77vj7,
};
//endregion

//# sourceMappingURL=ServerMessage.mjs.map
